/* eslint-disable no-param-reassign */
import React from "react";

import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { setWhitespacePieValues } from "../../../../store/components/Reports.slice";
import RenderComponent from "../../../General/RenderComponent";
import WhiteSpacePieChart from "../WhiteSpaceCharts/WhiteSpacePieChart";

function WhiteSpaceCategoryPie({
    category
}) {
    const {
        marketPackage
    } = useSelector((state) => state.buildTargets.setup);

    const dispatch = useDispatch();
    const [isLoadingPie, setIsLoadingPie] = useState(false);
    const [noData, setNoData] = useState(false);
    const [pieData, setPieData] = useState([]);

    useEffect(() => {
        setIsLoadingPie(true);
        WhiteSpaceServices.getOverAllPieChart(category).then((data) => {
            dispatch(setWhitespacePieValues({
                key: category.path,
                value: {
                    path: category.path,
                    title: category.title,
                    value: data
                }
            }));
            setPieData(data);
            setIsLoadingPie(false);
        });
    }, [category]);

    useEffect(() => {
        if (!pieData.reduce((acc, d) => {
            acc += d.score;
            return acc;
        }, 0)) {
            setNoData(true);
        } else {
            setNoData(false);
        }
    }, [pieData]);
    return (
        <div
            key={category.name}
            className="d-flex-col whitespace-chartItem"
            name={category.name}
            style={{
                width: "calc(100% - 2mm)",
                height: "145mm",
                border: "1px solid #E2E8F0",
                padding: "2mm",
                marginBottom: "2mm",
                borderRadius: "3px",
                backgroundColor: "var(--bluegray-100)"
            }}
        >
            <div style={{ padding: "4mm" }}>
                <span className="fs-19 fw-700 c-bg-700">
                    <span>{category.name}</span>
                    <span style={{
                        marginLeft: "2mm",
                        fontWeight: "normal"
                    }}
                    >
                        - Full Market Share of Consideration
                    </span>
                </span>
            </div>
            <RenderComponent
                isFullscreen
                loadingProps={{
                    loading: isLoadingPie,
                    description: "Loading Chart. Please wait..."
                }}
            >
                <WhiteSpacePieChart
                    data={pieData}
                    noData={noData}
                    upperCase={marketPackage?.code?.replace("dev", "") !== "healthcareclaims"}
                />
            </RenderComponent>
        </div>
    );
}

export default WhiteSpaceCategoryPie;
